<template>
  <transition name="fade-nav">
    <div v-show="isFloating" class="top-nav floating">
      <div class="nav-logo">
        <img src="/MijiLogo.png" alt="Miji Logo" />
      </div>
      <nav class="nav-center">
        <a href="#" @click.prevent="scrollToTop">{{ $t('nav.home') }}</a>
        <a href="#about" @click.prevent="scrollToAbout">{{ $t('nav.about') }}</a>
        <a href="mailto:mijigeor@gmail.com" class="email-btn">
          <!-- Email icon on mobile, text on desktop -->
          <span class="email-text">{{ $t('nav.emailMe') }}</span>
          <i class="mdi mdi-email"></i>
        </a>
      </nav>
      <div class="nav-right">
        <!-- Language selector moved to always-visible position -->
      </div>
    </div>
  </transition>
</template>




<script>
import translationMixin from '@/mixins/translationMixin';

export default {
  name: 'TopNav',
  mixins: [translationMixin],
  components: {
  },
  props: {
    floating: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFloating: false
    };
  },
  mounted() {
    if (this.floating) {
      window.addEventListener('scroll', this.handleScroll);
    }
  },
  beforeDestroy() {
    if (this.floating) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    handleScroll() {
      const triggerOffset = 50;
      const shouldFloat = window.scrollY > triggerOffset;
      if (this.isFloating !== shouldFloat) {
        this.isFloating = shouldFloat;
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    scrollToAbout() {
      const aboutSection = document.getElementById('about');
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: 'smooth' });
      }
    },
    onLanguageChanged(language) {
      // Handle language change event if needed
      console.log('Language changed to:', language);
    }
  }
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600&display=swap');
@import "~@mdi/font/css/materialdesignicons.css"; /* Import Material Icons */

/* Top Nav Layout */
.top-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 2rem;
  background-color: #fafafa;
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 1.25rem;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
}

.fade-nav-enter-active,
.fade-nav-leave-active {
  transition: opacity 0.4s ease;
}

.fade-nav-enter, 
.fade-nav-leave-to {
  opacity: 0;
}

.top-nav.floating {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fafafa;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.nav-logo {
  margin-right: 1.5rem; /* Space between logo and menu */
}

.nav-logo img {
  height: 60px;
}

.nav-center {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.nav-right {
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-right: 2.5rem;
}

.nav-center a {
  text-decoration: none;
  color: #000;
  font-weight: 600;
  transition: color 0.3s;
  display: flex;
  align-items: center;
}

.nav-center a.router-link-exact-active {
  color: #d26a00; /* Elegant orange */
}

.nav-center a:hover {
  color: #d26a00;
}

/* Email Me button styles */
.email-btn {
  display: flex;
  align-items: center;
  padding: 0.5rem 1.5rem;
  background-color: #d26a00;
  color: white !important;
  font-weight: bold;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  gap: 0.5rem;
  height: fit-content;
}

/* Hover effect for the email button */
.email-btn:hover {
  background-color: #b25400;
  color: white !important;
}

.email-btn i {
  font-size: 1.5rem; /* Adjust icon size */
}

.email-btn .email-text {
  display: inline; /* Show text on desktop */
}

.email-btn i {
  display: none; /* Hide icon by default */
}

/* Mobile styles */
@media (max-width: 768px) {
  .top-nav {
    padding: 0.5rem 1rem;
    font-size: 1.1rem;
  }

  .nav-logo {
    margin-right: 1rem;
  }

  .nav-logo img {
    height: 50px;
  }

  .nav-center {
    gap: 0.75rem;
  }

  .nav-right {
    padding-right: 2rem;
  }

  /* Show email icon and hide text on mobile */
  .email-btn .email-text {
    display: none;
  }

  .email-btn i {
    display: inline;
  }

  .email-btn {
    padding: 0.5rem;
  }
}

/* Extra small mobile styles */
@media (max-width: 480px) {
  .top-nav {
    padding: 0.5rem 0.75rem;
  }

  .nav-center {
    gap: 0.5rem;
  }

  .nav-logo {
    margin-right: 0.75rem;
  }

  .nav-logo img {
    height: 45px;
  }

  .nav-right {
    padding-right: 2.25rem;
  }
}

</style>